import InfluencerProgram from "./InfluencerProgram";
import ReferralProgram from "./Referral";
import Receta from "./Receta";
import SmartHome from "./SmartHome";
import HardwareTopology from "./HardwareTopology";
import Boogie from "./Boogie";
import HomeValueEstimator from "./HomeValueEstimator";
import CancerDetector from "./CancerDetector";
import PersonalSite from "./PersonalSite";

export default [
  InfluencerProgram,
  ReferralProgram,
  Receta,
  SmartHome,
  PersonalSite,
  HardwareTopology,
  Boogie,
  HomeValueEstimator,
  CancerDetector,
];
